import { useMemo } from 'react';

import { useNewUserAccessRights } from '@app/hooks';
import { NAccessRights } from '@app/types';

export const useAccessRightsToAi = () => {
  const {
    userAccessRights: { AiOperator, Users },
    organizationAccessRights,
  } = useNewUserAccessRights();

  const hasOrganizationRightToAi = useMemo(
    () =>
      !!organizationAccessRights?.find(
        ({ RightType }) => RightType === NAccessRights.RightType.AI
      )?.Allowed,
    [organizationAccessRights]
  );

  const hasUserSpecialRightToAi = useMemo(() => {
    return AiOperator.IsOn;
  }, [AiOperator]);

  const hasUserRightToEditUsers = useMemo(() => {
    return Users.IsEdit;
  }, [Users]);

  const hasUserRightToEditAiOperator = useMemo(() => {
    return (
      hasOrganizationRightToAi &&
      hasUserSpecialRightToAi &&
      hasUserRightToEditUsers
    );
  }, [
    hasOrganizationRightToAi,
    hasUserSpecialRightToAi,
    hasUserRightToEditUsers,
  ]);

  return {
    hasOrganizationRightToAi,
    hasUserSpecialRightToAi,
    hasUserRightToEditAiOperator,
  };
};
